module.exports = __webpack_public_path__ + "img/image5.184bbb9.webp";